export default "__VITE_ASSET__Dbxlh3b0__"